/* eslint-disable no-shadow */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";
import { PageWrapper, TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { BarLoader, Search as SearchBar } from "../../../shared/widgets";
import { fetchAllContractAction } from "../../../redux/action-creators/allContractsActionCreator";
import { setTokenExpired } from "../../../redux/actions/authActions";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import ContractModal from "../../../shared/components/commonComponents/ContractModal";

class VehicleContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      steps: this.getSteps(),
      content: [],
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      selected: [],
      searchString: "",
      vehicleDetails: {},
    };
    this.operatorContractGetList = this.operatorContractGetList.bind(this);
    this.operatorContractCloseDetailModal = this.operatorContractCloseDetailModal.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;
    this.operatorContractGetList();
    this.setState({
      vehicleDetails: location.state,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchString } = this.state;
    if (prevState && prevState.searchString !== searchString) {
      this.operatorContractGetList();
    }
  }

  handleSearchChange = (e) => {
    this.setState({
      searchString: e,
    });
  };

  handleChange = (input, value) => {
    const { fetchVehicles } = this.props;
    const { pageNo, searchString, rowsPerPage } = this.state;
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        fetchVehicles(null, pageNo, searchString, rowsPerPage);
      }
    });
  };

  handleAction(data) {
    this.openDetailModal(data);
  }

  getSteps() {
    return ["Terms", "Commercials"];
  }

  getExpenseDisplayName(name) {
    const expense = templateStrings.expenseArray.find((eachExpense) => eachExpense.name === name);
    return expense.label;
  }

  contractHandler = (data, requestType) => {
    const { vehicleDetails } = this.state;
    if (!vehicleDetails.borneBy) {
      return this.errorModalHandler(vehicleDetails.busNumber);
    }
    this.open(data, requestType);
    return null;
  };

  /**
   * Used to show Modal for "Add new Contract"
   */
  operatorContractdisplayDetailModal() {
    const { contractDetail } = templateStrings;
    return (
      <ContractModal
        inputProps={this.props}
        state={this.state}
        closeDetailModal={this.operatorContractCloseDetailModal}
        contractHandler={this.contractHandler}
        openConfirmationModal={this.openConfirmationModal}
        getExpenseDisplayName={this.getExpenseDisplayName}
        contractDetail={contractDetail}
        componentType="operator"
      />
    );
  }

  /**
   * API call to get vehicles.
   * @param pageNo current page number
   */
  operatorContractGetList() {
    const { fetchVehicles } = this.props;
    const { pageNo, searchString, rowsPerPage } = this.state;
    fetchVehicles(null, pageNo, searchString, rowsPerPage);
  }

  /**
   * Call when Add modal Opens.
   */
  open(data) {
    this.setState({
      showDetailModal: false,
      showConfirmationModal: false,
      showModal: true,
      contractDetails: data,
    });
  }

  /**
   * Call when Detail modal Opens.
   */
  openDetailModal(data) {
    this.setState({
      showConfirmationModal: false,
      showModal: false,
      showDetailModal: true,
      contractDetails: data,
    });
  }

  operatorContractCloseDetailModal() {
    this.setState({
      showDetailModal: false,
      contractDetails: null,
    });
  }

  /**
   * Call when Add modal Opens.
   */
  openConfirmationModal(dataId) {
    this.setState({
      showDetailModal: false,
      showConfirmationModal: true,
      contractId: dataId,
    });
  }

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      selected, pageNo, rowsPerPage, showDetailModal,
    } = this.state;

    const templateString = templateStrings.operatorVehicleContract;
    const header = "All Contracts";
    return (
      <div>
        <PageWrapper>
          <Hidden only={["sm", "xs"]}>
            <PageWrapper.Header heading={header} showBackArrow={false} hideS>
              <div className="pull-right search-container">
                <SearchBar placeHolder="Search Vehicle" onSearchChange={this.handleSearchChange} />
              </div>
            </PageWrapper.Header>
          </Hidden>

          <Hidden only={["lg", "xl", "md"]}>
            <PageWrapper.Header hideS>
              <div className="tabWrapper">
                <SearchBar placeHolder="Search Vehicle" onSearchChange={this.handleSearchChange} />
              </div>
            </PageWrapper.Header>
          </Hidden>
          <BarLoader scope="header" />

          <TableWrapper
            content={!headerLoader && content}
            selected={selected}
            pageNo={pageNo}
            uniqueKey="fromDate"
            rowsPerPage={rowsPerPage}
            count={totalItems}
            handleChange={this.handleChange}
            templateString={templateString}
            selectionAllowed={false}
            handleAction={this.handleAction}
          />
          {showDetailModal && this.operatorContractdisplayDetailModal()}
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
    state?.Contracts?.vehicleAllContracts?.items
      || [],
    totalItems:
      (state
        && state.Contracts
        && state.Contracts.vehicleAllContracts
        && state.Contracts.vehicleAllContracts.totalItems)
      || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    refreshUpliftStatus: state && state.Contracts && state.Contracts.refreshUpliftStatus,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchVehicles: (vehicleNo, pageNo, searchString) => {
    dispatch(fetchAllContractAction({ vehicleNo, pageNo, searchString }));
  },
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  setTokenExpired: (value) => {
    dispatch(setTokenExpired(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleContract);
